import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AllPlaysHome from './pages/AllPlaysHome';
import History from './pages/History';
import { fetchEnabledGames } from './api/lottery';
import { setEnabledGames } from './types/lottery';

function App() {
  const basename = (process.env.PUBLIC_URL || '').trim() || undefined;

  useEffect(() => {
    let cancelled = false;
    const refresh = () => {
      fetchEnabledGames()
        .then((items) => {
          if (cancelled) return;
          setEnabledGames(items.map((item) => ({
            code: item.code,
            title: item.title,
            shortTitle: item.shortTitle,
          })));
        })
        .catch(() => {
          // 接口失败时保持默认 GAMES 全量，避免首页空白
        });
    };
    refresh();
    // 每 60s 轮询，后台改 title/shortTitle 后用户最迟 1 分钟内看到
    const timer = window.setInterval(refresh, 60_000);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, []);

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<AllPlaysHome />} />
        <Route path="/lottery" element={<AllPlaysHome />} />
        <Route path="/featured" element={<Home />} />
        <Route path="/history" element={<History />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
